import "nanoscroller/bin/css/nanoscroller.css"
export default async () => await import("nanoscroller")
